import { baseScopesRequiredPerField } from '@atlassian/ui-modifications-core/constants';
import { isAriResourceIdValid } from '@atlassian/ui-modifications-public-api-utils/is-ari-resource-id-valid';
import { isNotEmptyString } from '@atlassian/ui-modifications-public-api-utils/is-not-empty-string';

export type PriorityPublicGetValue = {
	id: string;
	name: string;
	iconUrl?: string;
};

export type PriorityPublicSetValue = string;

export const validatePrioritySetValue = (value: unknown): value is PriorityPublicSetValue =>
	isNotEmptyString(value);

export const validatePriorityWithAriSetValue = (value: unknown): value is PriorityPublicSetValue =>
	isNotEmptyString(value) && isAriResourceIdValid(value);

export const priorityScopes = {
	...baseScopesRequiredPerField,
	granular: [...baseScopesRequiredPerField.granular, 'read:priority:jira'],
};
